"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterExpansionByDragAndDrop = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var dragAndDrop_1 = require("../../../dragAndDrop");
function useFilterExpansionByDragAndDrop(containsMultipleRows, isFilterBarExpanded, setFilterBarExpanded) {
    var lastCanDrop = react_1.useRef(false);
    var lastMultiRows = react_1.useRef(false);
    var shouldBeExpandedAfterDrop = react_1.useRef(false);
    var _a = tslib_1.__read(dragAndDrop_1.useDashboardDrop(["attributeFilter", "attributeFilter-placeholder"], {
        drop: function (_, monitor) {
            if (monitor.didDrop()) {
                shouldBeExpandedAfterDrop.current = true;
            }
        },
    }, []), 2), canDrop = _a[0].canDrop, dropRef = _a[1];
    react_1.useEffect(function () {
        var dragStateUnchanged = canDrop === lastCanDrop.current;
        var multiRowsUnchanged = containsMultipleRows === lastMultiRows.current;
        if (dragStateUnchanged && multiRowsUnchanged) {
            return;
        }
        if (canDrop && containsMultipleRows) {
            shouldBeExpandedAfterDrop.current = isFilterBarExpanded;
            setFilterBarExpanded(true);
        }
        else if (shouldBeExpandedAfterDrop.current !== isFilterBarExpanded) {
            setFilterBarExpanded(shouldBeExpandedAfterDrop.current);
            shouldBeExpandedAfterDrop.current = false;
        }
        lastCanDrop.current = canDrop;
        lastMultiRows.current = containsMultipleRows;
    }, [canDrop, containsMultipleRows, isFilterBarExpanded, setFilterBarExpanded]);
    return dropRef;
}
exports.useFilterExpansionByDragAndDrop = useFilterExpansionByDragAndDrop;
//# sourceMappingURL=useFilterExpansionByDragAndDrop.js.map